module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"suchen"},"en":{"search":"search"}}')
  delete Component.options._Ctor
}
